/* TNF single-variant direct add — bypass Quick Buy modal for products with 1 variant.
   2026-05-12. When the customer clicks Add to cart / Choose options on a single-variant
   product card, post /cart/add directly + pulse the cart icon — no modal, no drawer.
*/
(function () {
  if (window._tnfSingleVariantInited) return;
  window._tnfSingleVariantInited = true;

  // Inline pulse animation (matches tnf-cart-no-auto-open.js style — TNF yellow).
  // Inlined so this script is fully self-contained and can ship to live independently.
  if (!document.getElementById('tnf-svadd-style')) {
    var s = document.createElement('style');
    s.id = 'tnf-svadd-style';
    s.textContent = ''
      + '@keyframes tnfSvCartPulse {'
      + '  0%, 100% { transform: scale(1); color: inherit; }'
      + '  20% { transform: scale(1.5) rotate(-6deg); color: #ffd800; }'
      + '  40% { transform: scale(0.9) rotate(6deg); color: #ffd800; }'
      + '  60% { transform: scale(1.35) rotate(-3deg); color: #ffd800; }'
      + '  80% { transform: scale(0.95); color: #ffd800; }'
      + '}'
      + '.tnf-sv-cart-pulse { animation: tnfSvCartPulse 1s cubic-bezier(0.34, 1.56, 0.64, 1); transform-origin: center; }'
      + '@keyframes tnfSvCartCountPulse {'
      + '  0% { transform: scale(1); background: var(--tnf-cart-count-bg, #1e2d7d); color: #fff; box-shadow: 0 0 0 0 rgba(255,216,0,0); }'
      + '  20% { transform: scale(1.8); background: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 8px rgba(255,216,0,0.55); }'
      + '  50% { transform: scale(1.3); background: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 14px rgba(255,216,0,0); }'
      + '  80% { transform: scale(1.55); background: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 6px rgba(255,216,0,0.3); }'
      + '  100% { transform: scale(1); background: var(--tnf-cart-count-bg, #1e2d7d); color: #fff; box-shadow: 0 0 0 0 rgba(255,216,0,0); }'
      + '}'
      + '.tnf-sv-cart-count-pulse { animation: tnfSvCartCountPulse 1.1s cubic-bezier(0.34, 1.56, 0.64, 1); font-weight: 800 !important; }';
    document.head.appendChild(s);
  }

  function findCartIcon() {
    return document.querySelector('.header__cart-link, .header__cart-icon, .header-icons__icon--cart, a[href="/cart"]:not(.tnf-qbm-cart-view)');
  }
  function findCartCountBadge() {
    return document.querySelector('.header__cart-count, [data-cart-count], .header__cart-count-bubble, .header-icons__count, .cart-count-bubble');
  }
  function pulseCart() {
    var icon = findCartIcon();
    var count = findCartCountBadge();
    if (icon) {
      icon.classList.remove('tnf-sv-cart-pulse');
      void icon.offsetWidth;
      icon.classList.add('tnf-sv-cart-pulse');
      setTimeout(function () { icon.classList.remove('tnf-sv-cart-pulse'); }, 1100);
    }
    if (count) {
      count.classList.remove('tnf-sv-cart-count-pulse');
      void count.offsetWidth;
      count.classList.add('tnf-sv-cart-count-pulse');
      setTimeout(function () { count.classList.remove('tnf-sv-cart-count-pulse'); }, 1200);
    }
  }

  // Suppress drawer auto-open briefly. If tnf-cart-no-auto-open.js is loaded, it
  // already has its own logic — this is a no-op for that case (we only set/remove
  // the same body class). If not loaded, the brief suppression here is the only protection.
  function briefDrawerSuppress() {
    try {
      var d = document.querySelector('#mini-cart, .mini-cart, drawer-cart, cart-drawer, #cart-drawer, .drawer--cart');
      if (!d) return;
      // Continuously force-close for ~1.6s
      var until = Date.now() + 1600;
      var iv = setInterval(function () {
        if (Date.now() >= until) { clearInterval(iv); return; }
        var open = d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false' || d.classList.contains('drawer--open') || d.classList.contains('is-active');
        if (open) {
          d.classList.remove('is-open', 'drawer--open', 'is-active', 'mini-cart--open');
          d.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('drawer-open', 'cart-drawer-open', 'mini-cart-open', 'overflow-hidden', 'is-mini-cart-open');
        }
      }, 80);
    } catch (e) {}
  }

  // Cache for product variant counts to avoid re-fetching the same product.
  var variantCountCache = Object.create(null);
  function lookupVariantCount(handle) {
    if (!handle) return Promise.resolve(null);
    if (variantCountCache[handle] != null) return Promise.resolve(variantCountCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !Array.isArray(p.variants)) return null;
        variantCountCache[handle] = {
          count: p.variants.length,
          firstVariantId: p.variants[0] && (p.variants[0].id || p.variants[0]),
          firstAvailable: !!(p.variants[0] && p.variants[0].available)
        };
        return variantCountCache[handle];
      })
      .catch(function () { return null; });
  }

  function getCardHandle(card) {
    if (!card) return '';
    return card.dataset.productHandle
      || (function () {
           var a = card.querySelector('a[href*="/products/"]');
           if (!a) return '';
           var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
           return m ? m[1] : '';
         })();
  }

  // Read variant count from server-rendered card attribute if available (we add
  // `data-variant-count` in product-item.liquid). Returns null if unknown.
  function getCardVariantCount(card) {
    if (!card) return null;
    var n = parseInt(card.getAttribute('data-variant-count'), 10);
    return isNaN(n) ? null : n;
  }
  function getCardVariantId(card) {
    if (!card) return '';
    return card.getAttribute('data-first-variant-id') || card.getAttribute('data-variant-id') || '';
  }

  function postCartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function doDirectAdd(variantId, btn, card) {
    var originalText = btn && btn.textContent ? btn.textContent.trim() : '';
    if (btn) {
      btn.dataset.tnfBusy = '1';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.7';
    }
    briefDrawerSuppress();
    postCartAdd(variantId).then(function (r) {
      if (btn) {
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        btn.dataset.tnfBusy = '';
      }
      if (r) {
        pulseCart();
        try { window.dispatchEvent(new CustomEvent('tnf:cart:item-added')); } catch (e) {}
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'tnf_sv_direct_add', product_id: r.product_id, variant_id: r.variant_id, quantity: r.quantity });
        } catch (e) {}
      }
    }).catch(function () {
      if (btn) { btn.style.pointerEvents = ''; btn.style.opacity = ''; btn.dataset.tnfBusy = ''; }
    });
  }

  // Capture-phase listener so we run before the Quick Buy modal intercept.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('a.product-item__action-button, button.product-item__action-button');
    if (!btn) return;
    // Ignore Quick View / list-view buttons
    if (btn.classList.contains('product-item__action-button--list-view-only')) return;
    if (btn.dataset.tnfBusy === '1') { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var card = btn.closest('.product-item');
    if (!card) return;
    var handle = getCardHandle(card);
    if (!handle) return;
    var nServer = getCardVariantCount(card);

    // Case A — server told us the variant count.
    if (nServer === 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var vid = getCardVariantId(card);
      if (vid) {
        doDirectAdd(vid, btn, card);
      } else {
        // Server didn't dump the variant id — fall back to looking it up by handle
        lookupVariantCount(handle).then(function (info) {
          if (info && info.count === 1 && info.firstVariantId) doDirectAdd(info.firstVariantId, btn, card);
        });
      }
      return;
    }
    if (nServer != null && nServer > 1) return; // multi-variant — let QB modal handle

    // Case B — server didn't say. Look up async. We can't preventDefault here
    // because we already let the click bubble. Instead, prefetch on hover/touch
    // (next block) so subsequent clicks are fast. As a fallback: if the button
    // text is "add to cart" (single-variant Warehouse convention) intercept anyway.
    var btnText = (btn.textContent || '').trim().toLowerCase();
    if (btnText === 'add to cart' || btnText === 'sold out') {
      // 'Add to cart' on Warehouse = single-variant. Direct-add.
      e.preventDefault();
      e.stopImmediatePropagation();
      lookupVariantCount(handle).then(function (info) {
        if (info && info.count === 1 && info.firstVariantId && info.firstAvailable) doDirectAdd(info.firstVariantId, btn, card);
        else {
          // Multi-variant or unavailable — let user navigate to PDP / QB
          window.location.href = '/products/' + handle;
        }
      });
    }
  }, true);

  // Prefetch variant counts on hover/touchstart to keep clicks instant.
  function prefetch(e) {
    var card = e.target && e.target.closest && e.target.closest('.product-item');
    if (!card) return;
    if (card.dataset.tnfPrefetched === '1') return;
    var handle = getCardHandle(card);
    var nServer = getCardVariantCount(card);
    if (nServer != null) { card.dataset.tnfPrefetched = '1'; return; }
    if (!handle) return;
    card.dataset.tnfPrefetched = '1';
    lookupVariantCount(handle);
  }
  document.addEventListener('mouseenter', prefetch, true);
  document.addEventListener('touchstart', prefetch, true);
})();
